"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _invariant = _interopRequireDefault(require("invariant"));
var _memoizeOne = _interopRequireDefault(require("../helpers/memoizeOne"));
var _isShallowEqual = _interopRequireDefault(require("../helpers/isShallowEqual"));
var _styled = require("../styled");
var _createMediaQueries = _interopRequireDefault(require("./createMediaQueries"));
var _BreakpointContext = _interopRequireDefault(require("./BreakpointContext"));
// eslint is stupid
/* eslint-disable react/no-unused-prop-types */
/* eslint-enable react/no-unused-prop-types */
var mapPropsToState = (0, _memoizeOne.default)(function (props) {
  var breakpoints = Object.assign({}, props.theme.breakpoints, props.breakpoints);
  (0, _invariant.default)(breakpoints != null, '[BreakpointProvider] No breakpoints provided. ' + 'Ensure you have a `breakpoints` object in your theme, ' + 'or pass it explicitly to `BreakpointProvider`.');
  var mediaQueries = (0, _createMediaQueries.default)(breakpoints);
  var themeGrid = props.theme.grid != null ? props.theme.grid : {};
  return {
    context: {
      breakpoints: breakpoints,
      mediaQueries: mediaQueries
    },
    theme: Object.assign({}, props.theme, {
      breakpoints: breakpoints,
      media: mediaQueries,
      grid: Object.assign({}, themeGrid, {
        columns: props.columns != null ? props.columns : themeGrid.columns,
        gutter: props.gutter != null ? props.gutter : themeGrid.gutter,
        container: props.container || themeGrid.container
      })
    })
  };
}, _isShallowEqual.default);
var BreakpointProvider = function BreakpointProvider(props) {
  var state = mapPropsToState(props);
  return /*#__PURE__*/_react.default.createElement(_BreakpointContext.default.Provider, {
    value: state.context
  }, /*#__PURE__*/_react.default.createElement(_styled.ThemeProvider, {
    theme: state.theme
  }, props.children));
};
BreakpointProvider.defaultProps = {
  gutter: undefined,
  columns: undefined,
  breakpoints: undefined,
  container: undefined
};
var _default = exports.default = (0, _styled.withTheme)(BreakpointProvider);